import React from "react";
import Logo from "../images/logo-colorido.png";
import responsavelTecnico from "../images/responsavelTecnico.png";

const Header: React.FC = () => {
  return (
    <footer className="text-gray-600 body-font mb-10">
      <div className="container flex flex-col items-center px-5 pt-10 mx-auto  lg:flex-row lg:px-18 2lg:px-28">
        <img className="w-44 rounded-lg" alt="Desbloquear cartão" src={Logo} />
        <p className="text-center lg:text-left text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:py-2 sm:mt-0 mt-4">
          RUA IRMÃ FLÁVIA BORLET, 197 - BOQUEIRÃO, CURITIBA, PR - 81630-170 -
          (41) 3371-1900
        </p>
        <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
          <img
            className="w-32 rounded-lg"
            alt="Responsável técnico"
            src={responsavelTecnico}
          />
        </span>
      </div>
    </footer>
  );
};

export default Header;
